"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _cuid = _interopRequireDefault(require("cuid"));

var Bell = function Bell(props) {
  var uniqueId = (0, _cuid["default"])();
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({}, props, {
    uniqueId: uniqueId,
    iconName: "Bell"
  }), /*#__PURE__*/_react["default"].createElement("title", null, "bell"), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.42 11.98l-0.46-0.3c-0.571-0.394-0.94-1.045-0.94-1.783 0-0.006 0-0.012 0-0.018v0.001-2.26c0-2.894-2.346-5.24-5.24-5.24s-5.24 2.346-5.24 5.24v0 2.32c-0.013 0.732-0.387 1.374-0.952 1.755l-0.008 0.005c-0.463 0.334-0.761 0.872-0.761 1.48 0 1.005 0.815 1.82 1.82 1.82 0 0 0.001 0 0.001 0h10.86c0.908-0.011 1.64-0.75 1.64-1.66 0-0 0-0 0-0v0c0-0.004 0-0.008 0-0.013 0-0.559-0.283-1.052-0.714-1.343l-0.006-0.004zM15.46 13.58h-10.78c-0.221 0-0.4-0.179-0.4-0.4 0-0.13 0.062-0.246 0.159-0.319l0.001-0.001c0.922-0.655 1.517-1.718 1.52-2.92v-2.32c0.148-1.987 1.797-3.544 3.81-3.544s3.662 1.556 3.809 3.531l0.001 0.013v2.26c-0 0.005-0 0.011-0 0.017 0 1.24 0.63 2.332 1.587 2.975l0.013 0.008 0.44 0.3c0.057 0.041 0.095 0.106 0.1 0.179l0 0.001c0 0.122-0.098 0.22-0.22 0.22v0zM9.76 17.62c1.2-0.019 2.212-0.801 2.574-1.881l0.006-0.019h-5.16c0.368 1.099 1.38 1.881 2.578 1.9l0.002 0z",
    fill: "url(#".concat(uniqueId, ")")
  }));
};

var _default = Bell;
exports["default"] = _default;